import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { ApiStatusCode, AppConstant } from '@app/shared/constants';
import { Pattern } from '@app/shared/validators/pattern';
import { RequestColor } from '../../models/RequestColor';
import { RequestColorService } from '../../services/requestColor/requestColor.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';

@Component({
  selector: 'app-report-bug',
  templateUrl: './request-color.component.html',
  styleUrls: ['./request-color.component.css']
})
export class RequestColorComponent implements OnInit {

  requestColorForm: FormGroup;
  userId: number;

  constructor(
    private formBuilder: FormBuilder,
    private loader: LoaderService,
    private notificationService: NotificationService,
    private requestColorService: RequestColorService,
    private errorhandlerService: ErrorhandlerService
  ) {
    this.userId = Number(localStorage.getItem('userId'));

    this.requestColorForm = this.formBuilder.group({
      productTitle: new FormControl('', Validators.compose([Validators.required])),
      productColor: new FormControl('', Validators.compose([Validators.required])),
      description: new FormControl('', Validators.compose([Validators.required]))
    })
  }

  ngOnInit() {
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.requestColorForm.controls;
  }



  fn_SubmitRequest(formDirective: FormGroupDirective) {
    let value = this.requestColorForm.value;
    let data: RequestColor = {
      ProductTitle: value.productTitle,
      ProductColor: value.productColor,
      Description: value.description,
      UserId: this.userId
    };
    this.loader.show();
    
    this.requestColorService.SubmitRequestColor(data)
      .subscribe((res: any) => {
        if (res.StatusCode == ApiStatusCode.SUCCESS) {
          formDirective.resetForm();
          this.requestColorForm.reset();
          this.notificationService.success('Dear User, Your request has been received by the Merchloop team.', 'Confirmation Message');
        } else if (res.StatusCode === ApiStatusCode.BADREQUEST) {
          this.notificationService.error(res.Message, 'Try again');
        } else if (res.StatusCode === ApiStatusCode.INTERNAL_SERVER_ERROR) {
          this.notificationService.error('An error occured', 'Try again');
        }
        this.loader.hide();
      }, err => {
        console.error(err);
        this.errorhandlerService.handleError(err);
        this.loader.hide();
      });
  }

}
